// import React, { useEffect, useState } from 'react';
// import Header from './Header';
// import GameCarousel from './GameCarousel';
// import AllGames from './AllGames';
// import Cookies from 'js-cookie'
// import {useLocation,useNavigate} from 'react-router-dom'
// import axios from 'axios'

// function HomePage() {
//   const location = useLocation();
//   const [xmsisdn, setXmsisdn] = useState('');
//   console.log("xmsisdn",xmsisdn)
//   const navigate=useNavigate()
//   const loginurl = '/loginuser';
//   const serviceName = 'gameblitz'; // Define your service name here
//   useEffect(() => {
//     // Parse the URL search params to extract msisdn
//     const searchParams = new URLSearchParams(location.search);
//     const msisdnParam = searchParams.get('msisdn');
//     console.log("msisdn",msisdnParam)
//     setXmsisdn(msisdnParam);
//   }, [location.search]);

//     useEffect(() => {

//     if (xmsisdn) {
     
//       let data={
//         msisdn:xmsisdn,
//         service:"gameblitz"
//       }
//       console.log("data",data)
//       // Send a POST request with msisdn and serviceName in the request body
//       axios
//         .post(loginurl, data)
//         .then((response) => {
//           console.log("Login response:", response.data);
//           Cookies.set("msisdn",xmsisdn)
//           if(response.data.status=='0'){
//             navigate('/home/header')
//           }
//           // Handle the response if needed
//         })
//         .catch((error) => {
//           console.error("Error during login:", error);
//         });
//     }
//     else{
//       navigate('/home/header')
//     }
//   }, [xmsisdn, serviceName]);

//   // useEffect(() => {

//   //   if (xmsisdn) {
     
//   //     let data={
//   //       msisdn:xmsisdn,
//   //       service:"gameofyy"
//   //     }
//   //     console.log("data",data)
//   //     // Send a POST request with msisdn and serviceName in the request body
//   //     axios
//   //       .post(loginurl, data)
//   //       .then((response) => {
//   //         console.log("Login response:", response.data);
          
//   //         if(response.data.status=='0'){
//   //           navigate('/home/header')
//   //         }
//   //         else{
//   //           Cookies.set('msisdn', xmsisdn,{expires:1});
//   //         }
//   //         // Handle the response if needed
//   //       })
//   //       .catch((error) => {
//   //         console.error("Error during login:", error);
//   //       });
//   //   }
//   //   else{
//   //     navigate('/home/header')
//   //   }
//   // }, [xmsisdn]);
//   return (
//     <div className="h-screen flex flex-col overflow-hidden">
//       <Header  />
//       <div className="flex-grow overflow-y-auto bg-black">
//       <div className="max-w-[1640px] mx-auto p-4"  id="Heading">
//       <div className="max-h-[500px] relative">
//         <div className="absolute w-full h-full text-grey-200 max-h-[500px] bg-black/40 flex flex-col justify-center ">
//           <h1 className="px-4 text-4xl sm:text-5xl md:text-6xl lg:7xl font-bold ml-28  text-yellow-300   ">
//             Play<span className=" text-white"> unlimited </span>
//           </h1>
//           <h1 className="px-4 text-4xl ml-28 sm:text-5xl md:text-6xl lg:7xl font-bold text-yellow-300">
//           GAMES
//           </h1>
//       </div>
//       <img
//           className="w-full max-h-[500px] object-cover "
//           src="https://images4.alphacoders.com/129/1299410.jpg"
//           alt="logo"
//         />
//     </div>
//     </div>
//     <AllGames/>
//     </div>
 
//     </div>
//   );
// }

// export default HomePage;




import React, { useEffect, useState } from "react";
import Header from "./Header";
import AllGames from "./AllGames";
import Cookies from "js-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

function HomePage() {
  const location = useLocation();
  const navigate = useNavigate();

  const [xmsisdn, setXmsisdn] = useState("");
  const loginurl = "/loginuser";
  const serviceName = "gameblitz";

  // STEP 1: Extract msisdn from URL once
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const msisdnParam = searchParams.get("msisdn");
    console.log("msisdn from URL:", msisdnParam);
    if (msisdnParam) {
      setXmsisdn(msisdnParam);
    }
  }, [location.search]);

  // STEP 2: Trigger API call only AFTER msisdn is set
  useEffect(() => {
    if (!xmsisdn) return; // wait until msisdn exists

    const data = {
      msisdn: xmsisdn,
      service: serviceName,
    };

    console.log("Login request data:", data);

    axios
      .post(loginurl, data)
      .then((response) => {
        console.log("Login response:", response.data);

        if (response.data.status == "0") {
          Cookies.set("msisdn", xmsisdn);
          navigate("/home/header");
        } else {
          console.warn("Login failed or user not found");
        }
      })
      .catch((error) => {
        console.error("Error during login:", error);
      });
  }, [xmsisdn]); // runs only when xmsisdn updates

  // STEP 3: Optional fallback (if msisdn not found in URL)
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const msisdnParam = searchParams.get("msisdn");
    Cookies.set('msisdn',msisdnParam)
    if (!msisdnParam) {
      console.log("No msisdn found, redirecting...");
      navigate("/home/header");
    }
  }, [location.search, navigate]);

  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <Header />
      <div className="flex-grow overflow-y-auto bg-black">
        <div className="max-w-[1640px] mx-auto p-4" id="Heading">
          <div className="max-h-[500px] relative">
            <div className="absolute w-full h-full text-grey-200 max-h-[500px] bg-black/40 flex flex-col justify-center">
              <h1 className="px-4 text-4xl sm:text-5xl md:text-6xl lg:7xl font-bold ml-28 text-yellow-300">
                Play <span className="text-white">unlimited</span>
              </h1>
              <h1 className="px-4 text-4xl ml-28 sm:text-5xl md:text-6xl lg:7xl font-bold text-yellow-300">
                GAMES
              </h1>
            </div>
            <img
              className="w-full max-h-[500px] object-cover"
              src="https://images4.alphacoders.com/129/1299410.jpg"
              alt="logo"
            />
          </div>
        </div>
        <AllGames />
      </div>
    </div>
  );
}

export default HomePage;
